import { useEffect } from 'react';

import {
  DrawerStep,
  useDrawerSteps
} from '@/features/dashboard/components/Drawer/context/DrawerStepsContext';
import { useDashboardEditLockContext } from '@/features/dashboard/state/DashboardEditLockContext';
import { clearPendingAddAppDrawer } from '@/features/symbol-selector';
import { useAppDispatch, useAppSelector } from '@/store/hooks';

/**
 * Bridges the Redux `pendingAddAppDrawer` flag (set by the floating SymbolSelector
 * toolbar's "Create app" button) into the Dashboard's DrawerStepsContext.
 * Must be rendered inside DrawerStepsProvider.
 */
const DrawerOpenRequestHandler = () => {
  const pendingAddAppDrawer = useAppSelector(s => s.symbolSelector.pendingAddAppDrawer);
  const { setDrawerStep, drawerStep } = useDrawerSteps();
  const dispatch = useAppDispatch();
  const { requestEditLock } = useDashboardEditLockContext();

  useEffect(() => {
    if (pendingAddAppDrawer && !drawerStep) {
      dispatch(clearPendingAddAppDrawer());
      requestEditLock(() => {
        setDrawerStep(DrawerStep.SelectApp);
      });
    }
  }, [pendingAddAppDrawer, drawerStep, setDrawerStep, dispatch, requestEditLock]);

  return null;
};

export default DrawerOpenRequestHandler;
